import { render, staticRenderFns } from "./DISCOBJECT.search.source.component.vue?vue&type=template&id=31da11f7&"
import script from "./DISCOBJECT.search.source.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.search.source.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports